import axios from 'axios'
import store from '../../store'

export default {
  data() {
    return {}
  },
  methods: {
    capturaUrl() {
      return document.location.origin == 'http://sgp.fcc.org.br'
        ? 'https://extranet.fcc.org.br'
        : document.location.origin
    },
    resetarSenhaGenerico: function(item) {
      return new Promise((resolve, reject) => {
        const envioRecupera = {
          usuid: item.usuid,
          url: this.capturaUrl() + document.location.pathname + '#/recuperaSenha'
        }
        axios
          .post(
            store.state.baseUrlSegurancaSGP + 'Senha/recuperarsenha',
            envioRecupera,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resposta => {
            resolve(resposta)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    bloqueioUserGenerico: function(item) {
      return new Promise((resolve, reject) => {
        const user = {
          usuID: item.usuid,
          usuBloqueioAdm: item.usubloqueioadm
        }
        axios
          .put(
            store.state.baseUrlSegurancaSGP + 'Cadastro/bloqueioadm',
            user,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resposta => {
            resolve(resposta)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    deleteUserGenerico: function(item) {
      return new Promise((resolve, reject) => {
        axios
          .delete(
            store.state.baseUrlSegurancaSGP + 'Cadastro/excluirlogin?usuID=' + item.usuid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resposta => {
            resolve(resposta)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    editandoUserGenerico: function(xUser, complemento) {
      const item = {
        usuid: xUser.usuid,
        usuativo: xUser.usuativo,
        usuacessoexterno: xUser.usuacessoexterno,
        usuinterno: xUser.usuinterno,
        usupermiteemular: xUser.usupermiteemular,
        usupermiteseremulado: xUser.usupermiteseremulado,
        usutemporario: xUser.usutemporario,
        usuemailrecuperacaosenha: xUser.usuemailrecuperacaosenha,
        usureconhecimentofacial: xUser.usureconhecimentofacial,
        usuloginduasetapas: xUser.usuloginduasetapas,
        usupermitevariassecoes: true,
        usuarioparam: {
          usuid: xUser.usuid,
          notificacao: true,
          tema: 'default'
        },
        usuariocomplemento: {
          ...complemento,
          usucompstatus: xUser.usuativo,
          usuid: xUser.usuid,
          usucompdocto: this.removeAcento(complemento.usucompdocto),
          usucompdsemail: xUser.usuemailrecuperacaosenha
        }
      }

      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          store.state.baseUrlSegurancaSGP + 'Cadastro/alterarlogin',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(error => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    boasVindasGenerico: function(item) {
      return new Promise((resolve, reject) => {
        const envioBoasVindas = {
          usuid: item.usuid,
          url: this.capturaUrl() + document.location.pathname + '#/primeiroAcesso'
        }
        axios
          .post(
            store.state.baseUrlSegurancaSGP + 'Senha/processoboasvindas',
            envioBoasVindas,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resposta => {
            resolve(resposta)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}
